<template>
  <div :class="['perk-icon', `perk-icon--${side}`, { 'perk-icon--fallback': !hasVisual }]" aria-hidden="true">
    <img v-if="iconPath" class="perk-icon__image" :src="iconPath" alt="" decoding="async">
    <div v-else-if="hasSprite" :class="[side === 'killer' ? 'sprite-killer' : 'sprite-survivor', '_' + spriteKey]"></div>
    <div v-else class="perk-icon__fallback">
      <span>{{ initials }}</span>
      <i></i><i></i><i></i>
    </div>
  </div>
</template>

<script>
import gameIcons from '@/data/gameIconManifest.json'

export default {
  name: 'PerkIcon',
  props: {
    perk: { type: Object, required: true },
    side: { type: String, required: true }
  },
  computed: {
    iconPath () {
      const perks = gameIcons.perks && gameIcons.perks[this.side]
      return (perks && perks[this.perk.wikiId || this.perk.id]) || ''
    },
    hasSprite () {
      return this.perk.hasSprite !== false && Boolean(this.perk.spriteKey || this.perk.name)
    },
    hasVisual () {
      return Boolean(this.iconPath || this.hasSprite)
    },
    spriteKey () {
      return this.perk.spriteKey || this.perk.name
    },
    initials () {
      return String(this.perk.displayName || this.perk.name || '?')
        .replace(/^(hex|boon|scourge hook):\s*/i, '')
        .split(/\s+/)
        .slice(0, 2)
        .map(word => word.charAt(0))
        .join('')
        .toUpperCase()
    }
  }
}
</script>

<style lang="scss" scoped>
.perk-icon { width: 100%; height: 100%; display: grid; place-items: center; }
.perk-icon__image { width: min(88%, 178px); height: min(88%, 178px); object-fit: contain; filter: drop-shadow(0 13px 18px rgba(0,0,0,.5)); }
.perk-icon__fallback { width: 122px; height: 122px; border: 1px solid rgba(255,255,255,.22); background: radial-gradient(circle, rgba(104,220,255,.2), transparent 64%), #151a1e; display: grid; place-items: center; position: relative; transform: rotate(45deg); box-shadow: inset 0 0 34px rgba(104,220,255,.08), 0 14px 28px rgba(0,0,0,.34); }
.perk-icon--killer .perk-icon__fallback { background: radial-gradient(circle, rgba(255,98,91,.22), transparent 64%), #191516; box-shadow: inset 0 0 34px rgba(255,98,91,.08), 0 14px 28px rgba(0,0,0,.34); }
.perk-icon__fallback::before, .perk-icon__fallback::after { content: ''; inset: 9px; border: 1px solid rgba(255,255,255,.08); position: absolute; }
.perk-icon__fallback::after { inset: 18px; border-style: dashed; }
.perk-icon__fallback span { color: rgba(255,255,255,.86); font-size: 23px; font-weight: 950; letter-spacing: -.08em; transform: rotate(-45deg); }
.perk-icon__fallback i { width: 4px; height: 4px; border-radius: 50%; background: #68dcff; position: absolute; }
.perk-icon--killer .perk-icon__fallback i { background: #ff625b; }
.perk-icon__fallback i:nth-of-type(1) { top: 7px; left: 7px; }
.perk-icon__fallback i:nth-of-type(2) { right: 7px; top: 7px; }
.perk-icon__fallback i:nth-of-type(3) { right: 7px; bottom: 7px; }
@media (max-width: 760px) { .perk-icon__fallback { width: 92px; height: 92px; } }
</style>
